<template>
    <div class="home-box">
      <PageTitle :title="pageTitle" class="py-5"></PageTitle>
      <v-row align="center">
        <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
          <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
        </v-overlay>
  
        <div class="col-md-12 home-tabs-body">
          <ExpenseCreateForm :formData="formData" :mode="mode" :id="id" :proploading="loading"></ExpenseCreateForm>
        </div>
      </v-row>
    </div>
 </template>
      
<script>
import ExpenseCreateForm from "@/components/expenses/ExpenseCreateForm";
import PageTitle from "@/components/shared/PageTitle";
import { createNamespacedHelpers } from "vuex";

const { mapGetters } = createNamespacedHelpers("auth");
import { ExpenseService } from "@/services/expense-service.js";

export default {
    name: "CreateEditExpense",
    components: {
    PageTitle,
    ExpenseCreateForm,
    },
    props: {
    mode: { type: String, required: true }, 
    id: { type: String, default: null }, 
    },
    data() {
    return {
        loading: false,
        formData: {
        dr_id: "",
        amount: "",
        financial_year: "",
        branch : "",
        date_of_expense: new Date().toISOString().substr(0, 10),
        payee: "",
        description: "",
        payment_method: "",
        cr_id: "",
        invoices: null,
        project: ""  ,
        post:0,  
        },
    };
    },
    computed: {
    ...mapGetters({
        vuexloading: "loading",
        profile: "profile",
        hasPermission: "hasPermission",
    }),
    pageTitle() {
        return this.mode === "edit" ? "Update Expense" : "Create Expense";
    },
    },
    mounted() {
    if (this.mode === "edit") {
        this.fetchExpense();
    }
    },
    methods: {
    async fetchExpense() {
        if (!this.id) return;
        try {
        this.loading = true;
        const expense = await ExpenseService.getExpenseDetails(this.id);
        console.log("Edit fetched ",expense);
        this.formData = {
          dr_id: expense.dr_id,
          amount: expense.amount,
          financial_year: expense.financial_year_id,
          branch : expense.branch_id,
          date_of_expense: expense.date_of_expense,
          payee: expense.payee,
          description: expense.description,
          payment_method: expense.cr_id === 2 ? 'cash' : 'bank',
          cr_id: expense.cr_id,
          invoices: expense.invoices.file_path,
          project: expense.project  ,
          post: expense.post,  
        };
        } catch (error) {
        console.error(error);
        } finally {
        this.loading = false;
        }
    },
    },
};
</script>